(function () {
  'use strict';

  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('morningFlightPriorToLayoverNight', [
      'ui.router'
    ]);
}());
